import React from 'react'
import {useController} from 'react-hook-form'
import Select from 'react-select'
import {INPUT_NAMES, usePageContext} from 'Src/components/pages/SoftPull/PageContext'
import {useRegistrationContext} from 'Src/contexts/RegistrationContext'
import {customSelectStyles} from 'Src/utilities/customSelectStyles'
import {trans} from 'Src/utilities/Helpers'

const CityCounty = () => {
  const inputName = INPUT_NAMES.CITY_COUNTY
  const {control, cityListPlaceholder} = usePageContext()
  const {
    field,
    fieldState: {error},
  } = useController({
    control,
    name: inputName,
  })
  const {registrationState} = useRegistrationContext()
  const {cityListOptions, cityListLoading} = registrationState
  const selectValue =
    cityListOptions.find(
      (option) =>
        option?.value?.id === field.value?.id && option?.value?.inCity === field.value?.inCity
    ) || ''

  const handleSelectChange = (option) => field.onChange(option?.value)

  return (
    <div className="md:tw-w-8/12" aria-live="assertive" aria-atomic="false">
      <label htmlFor={inputName} className="required input-label tw-mb-2">
        {trans('city_county')}
      </label>
      <Select
        className="select"
        inputId={inputName}
        placeholder={cityListPlaceholder}
        isLoading={cityListLoading}
        isDisabled={!cityListOptions.length}
        styles={customSelectStyles}
        options={cityListOptions}
        isSearchable={false}
        {...field}
        onChange={handleSelectChange}
        value={selectValue}
      />
      {error?.message ? (
        <div>
          <span className="error">{error.message}</span>
        </div>
      ) : null}
    </div>
  )
}

export default CityCounty
